module.exports = __webpack_public_path__ + "static/img/pro-7-1-2.7d57b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/pro-7-1-2.png
// module id = VC3y
// module chunks = 0